import {
  GET_CIVILMATERIALCATEGORY,
  GET_CIVILMATERIALCATEGORY_SUCCESS,
  GET_CIVILMATERIALCATEGORY_FAIL,
  DELETE_CIVILMATERIALCATEGORY,
  DELETE_CIVILMATERIALCATEGORY_SUCCESS,
  DELETE_CIVILMATERIALCATEGORY_FAIL,
  UPDATE_CIVILMATERIALCATEGORY,
  UPDATE_CIVILMATERIALCATEGORY_SUCCESS,
  UPDATE_CIVILMATERIALCATEGORY_FAIL,
  ADD_NEW_CIVILMATERIALCATEGORY,
  ADD_CIVILMATERIALCATEGORY_SUCCESS,
  ADD_CIVILMATERIALCATEGORY_FAIL,
  CIVILMATERIALCATEGORY_LOADING,
  CIVILMATERIALCATEGORY_RESET
} from "./actionType";

export const resetCivilAccountCategoryState = (actionType) => ({
  type: CIVILMATERIALCATEGORY_RESET,
  payload: { actionType },
});

export const getCivilAccountCategorySuccess = (actionType, data) => ({
  type: GET_CIVILMATERIALCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getCivilAccountCategoryFail = (actionType, error) => ({
  type: GET_CIVILMATERIALCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getCivilAccountCategory = data => ({
  type: GET_CIVILMATERIALCATEGORY,
  payload: data,
});

export const getCivilAccountCategoryLoading = () => ({
  type: CIVILMATERIALCATEGORY_LOADING
});

export const deleteCivilAccountCategory = data => ({
  type: DELETE_CIVILMATERIALCATEGORY,
  payload: data,
});

export const deleteCivilAccountCategorySuccess = data => ({
  type: DELETE_CIVILMATERIALCATEGORY_SUCCESS,
  payload: data,
});

export const deleteCivilAccountCategoryFail = error => ({
  type: DELETE_CIVILMATERIALCATEGORY_FAIL,
  payload: error,
});

export const updateCivilAccountCategory = data => ({
  type: UPDATE_CIVILMATERIALCATEGORY,
  payload: data,
});

export const updateCivilAccountCategoryFail = error => ({
  type: UPDATE_CIVILMATERIALCATEGORY_FAIL,
  payload: error,
});

export const updateCivilAccountCategorySuccess = data => ({
  type: UPDATE_CIVILMATERIALCATEGORY_SUCCESS,
  payload: data,
});

export const addNewCivilAccountCategory = data => ({
  type: ADD_NEW_CIVILMATERIALCATEGORY,
  payload: data,
});

export const addCivilAccountCategorySuccess = data => ({
  type: ADD_CIVILMATERIALCATEGORY_SUCCESS,
  payload: data,
});

export const addCivilAccountCategoryFail = error => ({
  type: ADD_CIVILMATERIALCATEGORY_FAIL,
  payload: error,
});